import type { Product, ProductLeaf } from "@decocms/apps-commerce/types";
import { useEffect, useState } from "react";
import { sanitizeStoreUrl } from "~/utils/constants";

export interface Props {
  product: Product;
  productVariants: ProductLeaf[];
  link: string;
  isSelected: boolean;
}

const QuantityAvailable = (
  { product, productVariants, link, isSelected }: Props,
) => {
  const [inventory, setInventory] = useState<number | null>(null);
  const [selectedSku, setSelectedSku] = useState<string>("");

  useEffect(() => {
    if (link && productVariants.length && isSelected) {
      const productVariant = productVariants.find((variant: ProductLeaf) =>
        sanitizeStoreUrl(variant.url) === link
      );

      if (productVariant) {
        setSelectedSku(productVariant.sku);
      }
    }
  }, [productVariants, link, isSelected]);

  useEffect(() => {
    if (selectedSku) {
      const mapInventory = product.isVariantOf?.hasVariant?.find((item) =>
        item.sku === selectedSku
      );

      if (mapInventory) {
        const inventoryLevel =
          mapInventory.offers?.offers?.[0]?.inventoryLevel?.value || 0;
        setInventory(inventoryLevel);
      } else {
        setInventory(0);
      }
    }
  }, [selectedSku, product]);

  const showInventory = inventory !== null && inventory > 0 && inventory < 4;

  return (
    <div className={showInventory ? "tooltipQuantity" : ""}>
      {showInventory
        ? `${inventory} ${
          inventory === 1 ? "peça restante" : "peças restantes"
        }`
        : ""}
    </div>
  );
};

export default QuantityAvailable;
